import { createColumnHelper } from '@tanstack/react-table';
import { ChevronsUpDown, Pencil, Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button/button';
import { WithAuthorization } from '@/components/with-authorization';

import { RecipeTag } from '../types/recipe-tag-types';

const columnHelper = createColumnHelper<RecipeTag>();

export const makeColumns = (
  handleDelete?: (tag: RecipeTag) => void,
  handleEdit?: (tag: RecipeTag) => void,
) => [
  columnHelper.accessor('title', {
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
          className="w-[200px] px-0 justify-start"
        >
          Name
          <ChevronsUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: (info) => info.getValue(),
    size: 200,
  }),
  columnHelper.accessor('created_at', {
    header: 'Created',
    cell: (info) => new Date(info.getValue()).toLocaleDateString(),
    size: 120,
  }),
  columnHelper.display({
    id: 'actions',
    header: () => <div className="w-[100px]"></div>,
    cell: (info) => (
      <WithAuthorization authorizedRoles={['admin', 'editor']}>
        <div className="flex gap-2 justify-end">
          <Button
            variant="ghost"
            size="icon"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit?.(info.row.original);
            }}
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="text-destructive hover:bg-destructive/10"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete?.(info.row.original);
            }}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </WithAuthorization>
    ),
    size: 100,
  }),
];
